// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CellAdjustment .flyout-item-label,.CellTextAlignment .flyout-item-label{text-transform:none!important}.CellAdjustment{min-width:250px!important}.CellTextAlignment{min-width:200px!important}.CellFormat{min-width:300px!important}", ""]);
// Exports
module.exports = exports;
